$(function () {
  function end_loader() {
    $('.loader').fadeOut(400);
  }

  $(window).on('load', function () {
    setTimeout(function () {
      end_loader();
    }, 1500);
  });

  setTimeout(function () {
    $('.loader').css('display', 'none').attr('style', function (i, style) {
      return style + '; display: none !important;';
    });
  }, 3000);
});